import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      setMtoItem: 'cart/setMtoItem',
      setItemQuantity: 'cart/setItemQuantity',
    }),
    /**
     * Method to add item modifier to cart
     * @param {Object} item
     * @param {Object} lineItem
     * @param {Object} variation
     */
    async addItemModifierToCart(item, lineItem, variation) {
      const mtoVariation = variation.id;
      const total = item.actualPrice + variation.priceOfModifiers;

      if (lineItem) {
        await this.setItemQuantity({
          item,
          variation: mtoVariation,
          quantity: 0,
        });
      }

      this.setMtoItem({
        lineItem,
        item,
        variation: mtoVariation,
        amount: total,
      });
    },
  },
};
